import React from 'react';

export const SvgIcYogaStudio = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="4.9" r="2.3" fill={props.color || 'currentColor'} />
    <path
      d="M12 8c-1.8 0-3.3 1.4-3.3 3.1 0 .8.3 1.5.9 2-.6.2-1.2.5-1.7.9-1 .7-1.6 1.7-1.8 2.9-.1.5.3 1 .8 1.1.5.1 1-.2 1.1-.8.1-.7.5-1.2 1-1.6.6-.4 1.3-.6 2-.6h2c.7 0 1.4.2 2 .6.5.4.9.9 1 1.6.1.6.6.9 1.1.8.5-.1.9-.6.8-1.1-.2-1.2-.8-2.2-1.8-2.9-.5-.4-1.1-.7-1.7-.9.6-.5.9-1.2.9-2 0-1.7-1.5-3.1-3.3-3.1Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M5.6 18.1c1.8-.8 4-1.2 6.4-1.2s4.6.4 6.4 1.2c.6.3.8.9.5 1.4-.2.5-.8.7-1.3.5-1.5-.6-3.5-1-5.6-1s-4.1.4-5.6 1c-.5.2-1.1 0-1.3-.5-.3-.5-.1-1.1.5-1.4Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcBeautyCenterSpa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 3.2c-1.5 1.4-2.4 3-2.4 4.6 0 .9.3 1.7.8 2.4-1-.5-2.2-.8-3.5-.8-1.3 0-2.6.3-3.7.9 1 2.4 3.6 4.1 6.7 4.1h.2v3.2h-2.7c-.5 0-.9.4-.9.9s.4.9.9.9h7.2c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-2.7v-3.2h.2c3.1 0 5.7-1.7 6.7-4.1-1.1-.6-2.4-.9-3.7-.9-1.3 0-2.5.3-3.5.8.5-.7.8-1.5.8-2.4 0-1.6-.9-3.2-2.4-4.6Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcSocialLounges = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.6 10.4V8.6C5.6 7.7 6.3 7 7.2 7h9.6c.9 0 1.6.7 1.6 1.6v1.8c-.9.2-1.6 1-1.6 2v1.2H7.2v-1.2c0-1-.7-1.8-1.6-2Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M3.6 10.6c1 0 1.8.8 1.8 1.8V15h13.2v-2.6c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8V16c0 .7-.6 1.3-1.3 1.3H3.1c-.7 0-1.3-.6-1.3-1.3v-3.6c0-1 .8-1.8 1.8-1.8Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M4.6 17.6h1.7v1.9c0 .4-.3.7-.7.7H5.3c-.4 0-.7-.3-.7-.7v-1.9Zm13.1 0h1.7v1.9c0 .4-.3.7-.7.7h-.3c-.4 0-.7-.3-.7-.7v-1.9Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcCoffeeCorner = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M4.6 9.4h11v4.7a4 4 0 0 1-4 4H8.6a4 4 0 0 1-4-4V9.4Z" fill={props.color || 'currentColor'} />
    <path
      d="M15.6 10.3h1.7a2.6 2.6 0 0 1 0 5.2h-1.4v-1.7h1.4a.9.9 0 0 0 0-1.8h-1.7v-1.7Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M4 19.1h12.2c.5 0 .9.4.9.9s-.4.9-.9.9H4c-.5 0-.9-.4-.9-.9s.4-.9.9-.9Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M8 3.2c.5.6.5 1.3 0 1.9-.4.5-.4 1 0 1.5l-1-.1c-.5-.7-.5-1.6 0-2.3.3-.3.3-.6 0-.9l1-.1Zm3.6 0c.5.6.5 1.3 0 1.9-.4.5-.4 1 0 1.5l-1-.1c-.5-.7-.5-1.6 0-2.3.3-.3.3-.6 0-.9l1-.1Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcFamilyEntertainmentAreas = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="6.4" cy="6.6" r="2.2" fill={props.color || 'currentColor'} />
    <path
      d="M6.4 9.4c-2.1 0-3.4 1.5-3.4 3.6v4.1c0 .5.4.9.9.9h.7l.4 1.7c.1.4.4.6.8.6h1.4c.4 0 .7-.2.8-.6l.4-1.7h.7c.5 0 .9-.4.9-.9V13c0-2.1-1.4-3.6-3.4-3.6Z"
      fill={props.color || 'currentColor'}
    />
    <circle cx="17.6" cy="6.6" r="2.2" fill={props.color || 'currentColor'} />
    <path
      d="M17.6 9.4c-2.1 0-3.4 1.5-3.4 3.6v4.1c0 .5.4.9.9.9h.7l.4 1.7c.1.4.4.6.8.6h1.4c.4 0 .7-.2.8-.6l.4-1.7h.7c.5 0 .9-.4.9-.9V13c0-2.1-1.4-3.6-3.4-3.6Z"
      fill={props.color || 'currentColor'}
    />
    <circle cx="12" cy="10.4" r="1.8" fill={props.color || 'currentColor'} />
    <path
      d="M12 12.6c-1.7 0-2.8 1.2-2.8 2.9v3.3c0 .4.3.7.7.7h.6l.3 1.3c.1.3.3.5.6.5h1.2c.3 0 .5-.2.6-.5l.3-1.3h.6c.4 0 .7-.3.7-.7v-3.3c0-1.7-1.1-2.9-2.8-2.9Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcKidsActivityZones = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 13.2c0-.6.4-1 1-1h5.4c.6 0 1 .4 1 1v5.4c0 .6-.4 1-1 1H4.5c-.6 0-1-.4-1-1v-5.4Zm2.6 1.3a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1 13.2c0-.6.4-1 1-1h5.4c.6 0 1 .4 1 1v5.4c0 .6-.4 1-1 1h-5.4c-.6 0-1-.4-1-1v-5.4Zm1.5 1.5 1.5 1.5 1.5-1.5 1 1-1.5 1.5 1.5 1.5-1 1-1.5-1.5-1.5 1.5-1-1 1.5-1.5-1.5-1.5 1-1Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3 4.6c0-.6.4-1 1-1h5.4c.6 0 1 .4 1 1V10c0 .6-.4 1-1 1H9.3c-.6 0-1-.4-1-1V4.6Zm2.7 1c-.5 0-.9.2-1.2.5l1.2 1.1 1.2-1.1c-.3-.3-.7-.5-1.2-.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcCinema = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.5h18a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1Zm1.2 2.1v1.7h2.1V8.6H4.2Zm0 3.4v1.7h2.1V12H4.2Zm0 3.4v1.4h2.1v-1.4H4.2ZM17.7 8.6v1.7h2.1V8.6h-2.1Zm0 3.4v1.7h2.1V12h-2.1Zm0 3.4v1.4h2.1v-1.4h-2.1ZM8 8.6v6.8h8V8.6H8Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcGamingVrZone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M9 5.6h6c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H9c-.5 0-.9.4-.9.9s.4.9.9.9Z" fill={props.color || 'currentColor'} />
    <path
      d="M4.2 7.6c-1.3 0-2.2 1-2.2 2.3v4.2c0 1.4 1 2.5 2.4 2.5h2.7c.7 0 1.4-.4 1.8-1l1-1.5c.4-.6 1.2-.6 1.6 0l1 1.5c.4.6 1 1 1.8 1h2.7c1.4 0 2.4-1.1 2.4-2.5V9.9c0-1.3-.9-2.3-2.2-2.3H4.2Zm2.3 2.9a1.7 1.7 0 1 1 0 3.4 1.7 1.7 0 0 1 0-3.4Zm11 0a1.7 1.7 0 1 1 0 3.4 1.7 1.7 0 0 1 0-3.4Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcBilliards = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M3.6 4.1 14 14.5l-1.5 1.5L2.1 5.6a1.05 1.05 0 0 1 1.5-1.5Z" fill={props.color || 'currentColor'} />
    <circle cx="6.6" cy="16.6" r="2.5" fill={props.color || 'currentColor'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6 9.2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 3.4a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcTableTennis = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M9.9 2.7C6.3 2.7 3.4 5.5 3.4 8.9c0 2.9 2.1 5.3 4.9 5.8l.7 4.6a1.3 1.3 0 0 0 2.6 0l.7-4.6c2.8-.5 4.9-2.9 4.9-5.8 0-3.4-2.9-6.2-6.5-6.2Z"
      fill={props.color || 'currentColor'}
    />
    <circle cx="18.8" cy="5.4" r="2.1" fill={props.color || 'currentColor'} />
  </svg>
);
export const SvgIcMeetingEventsRooms = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <ellipse cx="12" cy="12" rx="6.3" ry="3.7" fill={props.color || 'currentColor'} />
    <circle cx="12" cy="5.2" r="1.9" fill={props.color || 'currentColor'} />
    <circle cx="12" cy="18.8" r="1.9" fill={props.color || 'currentColor'} />
    <circle cx="4.6" cy="12" r="1.9" fill={props.color || 'currentColor'} />
    <circle cx="19.4" cy="12" r="1.9" fill={props.color || 'currentColor'} />
  </svg>
);
export const SvgIcReceptionConciergeAreas = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="3.6" r="1.3" fill={props.color || 'currentColor'} />
    <path
      d="M11 5.2v.7c-3.3.5-5.8 3.3-5.8 6.7v2.6h13.6v-2.6c0-3.4-2.5-6.2-5.8-6.7v-.7a1 1 0 0 0-2 0Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M3.4 16.2h17.2c.6 0 1 .45 1 1s-.4 1-1 1H3.4c-.6 0-1-.45-1-1s.4-1 1-1Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcCoWorkingStudySpaces = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6 5.6h12c.9 0 1.6.7 1.6 1.6v7.2H4.4V7.2C4.4 6.3 5.1 5.6 6 5.6Zm.8 2.2v5.2h10.4V7.8H6.8Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M2.6 15.6h18.8l-.9 2a1.6 1.6 0 0 1-1.5 1H5a1.6 1.6 0 0 1-1.5-1l-.9-2Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
export const SvgIcReadingLibraryQuietZones = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 7C10 5.6 7 5 4 5.4 3.4 5.5 3 6 3 6.6V16.4C3 17 3.5 17.4 4.1 17.3 6.6 16.9 9.6 17.2 12 18.6V7Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M12 7C14 5.6 17 5 20 5.4 20.6 5.5 21 6 21 6.6V16.4C21 17 20.5 17.4 19.9 17.3 17.4 16.9 14.4 17.2 12 18.6V7Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
